import { Injectable } from '@angular/core';
import {ModelTeacherprofile} from '../../model/model.teacherprofile';
import {ApiService} from './api.service';
import {Observable, of} from 'rxjs';
import {ModalService} from './modal.service';

@Injectable({
  providedIn: 'root'
})
export class TeacherService {

  constructor(private api: ApiService,
              private modal: ModalService) {

  }



  /**
   * Get current student profile data
   */
  apiGetTeacherProfileCurrent() {
    this.api.setEndpoint('teacherprofile/current');
    return this.api.GET<ModelTeacherprofile>();
  }

  /**
   * Create teacher profile
   * @param data
   */
  apiCreateTeacherprofile(data:any) {
    this.api.setEndpoint('teacherprofile');
    return this.api.POST<any>(data);
  }

  /**
   * Create student profile
   * @param data
   */
  apiRegisterTeacherprofile(data:any) {
    this.api.setEndpoint('teacherprofile/register');
    return this.api.POST<any>(data);
  }

  /**
   * Delete a / own student profile
   * @param profile_id
   */
  apiDeleteTeacherprofile(profile_id:string) {
    this.api.setEndpoint('teacherprofile/' + profile_id);
    return this.api.DELETE();
  }

  /**
   * Error handler
   *
   * @param operation
   * @param result
   */
  handleError<T>(operation:string = '', result?: T) {
    return (error: any): Observable<T> => {

      // Handle given operation
      switch (operation) {

        case 'apiGetAccountCurrent':
        case 'apiGetTeacherProfileCurrent':
          // Do not perform any action, profile could be non-existing
          break;

        default:
          console.log('error operation: ', operation);
          this.modal.Alert('Error', 'Something went wrong, please try again');
          break;

      }

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}
